// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__t6ehd","withValue":"style__withValue__q76fV"};